var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Avatar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.8,
    viewBox: "0 0 32 31.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Avatar .cls-1 {\n        fill: #c5d75d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_107",
    "data-name": "Pfad 107",
    className: "cls-1",
    d: "M15.8,15.5A7.79,7.79,0,0,1,8,7.8a7.8,7.8,0,0,1,15.6,0A7.725,7.725,0,0,1,15.8,15.5Zm0-13.6a5.8,5.8,0,1,0,5.8,5.8A5.8,5.8,0,0,0,15.8,1.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_108",
    "data-name": "Pfad 108",
    className: "cls-1",
    d: "M20.8,15.9l-.3.2a9.609,9.609,0,0,1-9.3,0l-.4-.1L0,18.8l.3.9A16.154,16.154,0,0,0,16,31.8a16.381,16.381,0,0,0,15.7-12l.3-.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.9eb3bfa41a13525fec90d4089223e01f.svg";
export { ForwardRef as ReactComponent };